module.exports = __webpack_public_path__ + "img/invoicepar_logo.072ae44d.jpeg";